import { render, staticRenderFns } from "./shuiwufuwu.vue?vue&type=template&id=201b34fe&scoped=true&"
import script from "./shuiwufuwu.vue?vue&type=script&lang=js&"
export * from "./shuiwufuwu.vue?vue&type=script&lang=js&"
import style0 from "./shuiwufuwu.vue?vue&type=style&index=0&id=201b34fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b34fe",
  null
  
)

export default component.exports